
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { SlashNConverter } from '~/utils/'

export default {
    props: {
        conData: {
            type: [String, Object, Array],
        },
    },
    data() {
        return {
            componentKey: 0,
            html: '',
            lastUpdate: '',
        }
    },
    watch: {
        conData() {
            console.log('typeof conData', typeof this.conData)

            /**
             * 시황 - 채권 / 뉴욕채권
             * subTitle 추가
             * 210913 이민수
             */
            const titleList = [
                '[국내증시와의 상관관계]',
                '[관련업종 및 관련테마/종목]',
            ]

            if (this.conData) {
                this.html = ''
                for (const value of this.conData) {
                    this.html += SlashNConverter(value.content)
                    this.html += `${
                        titleList.length > 0
                            ? '<hr>' +
                              '<h1>' +
                              titleList.reverse().pop() +
                              '</h1>'
                            : ''
                    }`
                }
            }
            // rerender 문제 해결 방법
            console.log('updated')
            this.forceRerender()
            // 22.04.01 suye 작성일자 추가 
            for (let i = 0; i < this.conData.length; i++) {
                const lastTimeDate = this.conData[i].lastUpdateTime
                const stringDate = lastTimeDate.substring(0, 4) + '/' + lastTimeDate.substring(4, 6) + '/' + 
                lastTimeDate.substring(6, 8) + ' ' + lastTimeDate.substring(8, 10) + ':' + lastTimeDate.substring(10, 12)
                console.log('lastTimeDate: ', stringDate)
                this.lastUpdate = stringDate
            }
        },
    },
    methods: {
        // 하위 컴포넌트 렌더링 문제
        forceRerender() {
            this.componentKey += 1
        },
    },
}
